import useCompanyLogo from '@/hooks/useCompanyLogo';
import { ThemeData } from '../types';

function FullPageLoader({ themeData }: { readonly themeData?: ThemeData }) {
  const { logo, isCustomLogoPresent } = useCompanyLogo({
    themeData,
    className: 'h-full w-36 animate-pulse',
    isFullPageLoader: true,
  });

  return (
    <div
      style={{ backgroundColor: isCustomLogoPresent ? themeData?.['chat-consent-bg'] : '#FFFFFF' }}
      className="fixed inset-0 flex items-center justify-center w-full h-full text-center z-100"
    >
      <div className="flex flex-col items-center justify-center">{logo}</div>
    </div>
  );
}

export default FullPageLoader;
